import Icon from "../../../Elements/Icon/Icon.tsx";
import Image from "../../../Elements/Image/Image.tsx";
import React, { useRef, useState } from "react";
import { useModal } from "../../../../contexts/modalContext/modalContext.js";
import Button from "../../../Elements/Button/Button.js";
import { useContent } from "../../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../../contexts/userContext/userContext.js";
import apiRequest from "../../../../utils/ApiRequest/apiRequest.js";
import { useCookie } from "../../../../contexts/cookieContext/cookieContext.js";
import { newLinkUrl } from "../Helpers.js";
import parse from "html-react-parser";
import useOnClickOutside from "hooks/useOnClickOutside.js";
import AnimationContainer from "components/Reusable/AnimationContainer/AnimationContainer.js";
import YoutubeHomePromo from "components/Pages/Home/Reusable/YoutubeHomePromo.js";

import "./PopUpNotifications.scss";

const PopUpContainerNotifications = ({
  data,
  previewAdmin,
  isSpecial = null,
  isHomePage
}) => {
  const PREVENT_CLOSE_CLASS_NAME = "prevent-close-notification";

  const { setCookies, getCookie, removeCookies } = useCookie();
  const [show, setShow] = useState(true);
  const { isLoggedIn, getUserData } = useUser();
  const { closeModal } = useModal();
  const { getLanguage, getTextByKey } = useContent();
  const notificationRef = useRef();

  const notificationAction = () => {
    if (!previewAdmin) {
      updateCookie();
      if (isLoggedIn()) {
        let tempData = { ...data };
        tempData.UserNotificationClicked = true;
        tempData.UserNotificationDisplayed = true;
        updateUserNotification(tempData);
      } else {
        updateNotificationStatistics();
      }
      // if (data) {
      //   redirectByClick(data, getLanguage());
      // }
    } else {
      //redirectByClick(data, getLanguage());
    }

    closeModal();
  };

  const fixPopUpButtonLink = (str) => {
    let temp = str;
    if (temp) {
      if (getUserData()) {
        if (getUserData().Subscribtion_Expired) {
          temp = temp.replace("#subscriptiontype#", "subscription");
          if (getUserData().Subscription === "JM Business") {
            temp = temp.replace("#subscriptionpackage#", "business");
          } else if (getUserData().Subscription === "JM Pro") {
            temp = temp.replace("#subscriptionpackage#", "pro");
          }
        }
      }
    }
    return temp;
  };

  const closeNotification = (e) => {
    // don't close side panel if target includes specific class
    if (e.target.className.includes(PREVENT_CLOSE_CLASS_NAME)) return;

    if (!previewAdmin) {
      updateCookie();
      if (isLoggedIn()) {
        let tempData = { ...data };
        tempData.UserNotificationDisplayed = true;
        updateUserNotification(tempData);
      }
    }

    if (isSpecial) {
      if (isLoggedIn()) {
        let tempData = { ...data };
        tempData.UserNotificationDisplayed = true;
        updateUserNotification(tempData);
      } else {
        updateNotificationStatistics();
      }
      window.location.href = data.CancelDestinationUrl;
    }

    closeModal();
    setShow(false);
  };

  const updateCookie = () => {
    const cookie = getCookie("HomeNotification");
    if (cookie) {
      const newCookie =
        cookie + "_" + data.NotificationSystemName.toLowerCase();
      removeCookies("HomeNotification");
      setCookies("HomeNotification", newCookie);
    } else {
      removeCookies("HomeNotification");
      setCookies("HomeNotification", data.NotificationSystemName.toLowerCase());
    }
  };

  const updateUserNotification = async (item) => {
    const body = {
      UserNotificationId: item.NotificationId,
      TemplateNotificationId: item.TemplateId,
      UserNotificationUserId: item.UserId,
      UserNotificationDisplayed: item.UserNotificationDisplayed,
      UserNotificationClicked: item.UserNotificationClicked,
      UserNotificationImportant: item.UserNotificationImportant,
      UserNotificationHidden: item.UserNotificationHidden,
    };
    const response = await apiRequest(
      "Notifications",
      "UpdateUserNotification",
      body,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
      }
    }
  };

  const updateNotificationStatistics = async () => {
    const parameters = { systemName: data.NotificationSystemName };
    const response = await apiRequest(
      "Notifications",
      "UpdateStatisticsNotificationAnonymousUserReact",
      parameters
    );
    if (response.status === "success") {
      if (response.data) {
      }
    }
  };

  const redirectToPurchasePage = () => {
    //get cookie CouponCodeOfferSubscription
    let couponCode = getCookie("CouponCodeOfferSubscription");
    if (couponCode) {
      window.location.href =
        fixPopUpButtonLink(newLinkUrl(data, getLanguage())) +
        "?coupon=" +
        couponCode;
    } else {
      getCouponCode();
    }
  };

  const getCouponCode = async () => {
    //CreateCouponOfferSubscriptionReact

    const response = await apiRequest(
      "Coupons",
      "CreateCouponOfferSubscriptionReact",
      null,
      "POST"
    );
    if (response.status === "success") {
      if (response.data) {
        if (isLoggedIn()) {
          let tempData = { ...data };
          tempData.UserNotificationClicked = true;
          tempData.UserNotificationDisplayed = true;
          updateUserNotification(tempData);
        } else {
          updateNotificationStatistics();
        }
        let couponCode = response.data;
        //save the coupon code in the cookie for 24 hours from now with maxAge
        setCookies("CouponCodeOfferSubscription", couponCode, {
          maxAge: 60 * 60 * 24,
        });
        window.location.href =
          fixPopUpButtonLink(newLinkUrl(data, getLanguage())) +
          "?coupon=" +
          couponCode;
      }
    }
  };

  //if click outside modal close modal and run closeNotification function ref notificationRef
  useOnClickOutside(notificationRef, (e) => closeNotification(e));

  return (
    <AnimationContainer
      animationClassName={"side-bar-animation"}
      animationOn={data !== undefined && show}
    >
      <div className={`modal-side-notification`}>
        <div
          className="popup-notifications-container"
          onClick={(e) => e.stopPropagation()}
          ref={notificationRef}
        >
          <button
            className="modal-close-button"
            onClick={(e) => closeNotification(e)}
          >
            <Icon large name="x" />
          </button>
          <div className="popup-body">
            <div className="details-side">
              <div className="title-logo">
                <Icon name="mobile-icon-jumbomail" />
              </div>
              <div className="popup-title">
                {parse(
                  data && data.NotificationTitle && data.NotificationTitle
                )}
              </div>
              <div className="image-side">
                {data && data.NotificationImage && (
                  <div className="popup-image">
                    <Image
                      title={
                        data && data.NotificationTitle && data.NotificationTitle
                      }
                      alt={
                        data && data.NotificationTitle && data.NotificationTitle
                      }
                      src={
                        data && data.NotificationImage && data.NotificationImage
                      }
                    />
                  </div>
                )}
              </div>
              <div className="video-side">
                {(data && data.NotificationVideoLink) ||
                window.location.href.includes("preview-notification-48") ? (
                  <YoutubeHomePromo link={data.NotificationVideoLink} />
                ) : null}
              </div>
              <div className="popup-text">
                {parse(data && data.NotificationText && data.NotificationText)}
              </div>
            </div>

            {data.NotificationLinkUrl ? (
              <div className="popup-buttons">
                <Button>
                  <a
                    onClick={() => notificationAction()}
                    target={data.NotificationLinkTarget}
                    href={fixPopUpButtonLink(newLinkUrl(data, getLanguage()))}
                  >
                    {data.ButtonText}
                  </a>
                </Button>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </AnimationContainer>
  );
};

export default PopUpContainerNotifications;
